if (!customElements.get("personalize-birthdate-candle-flow")) {
  customElements.define(
    "personalize-birthdate-candle-flow",
    class PersonalizeBirthdateCandleFlow extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.personalizeForm = document.querySelector("#personalize-form");
        this.resultBackButton = document.querySelector(
          "#personalize-result-back-btn"
        );
        this.heroContent = document.querySelector("#product-hero-content");
        this.personalizeResultBlock = document.querySelector(
          "#personalize-result"
        );
        this.personaliseAddToCartBtn = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.productData = JSON.parse(document.querySelector('.js-product-json')?.textContent || '{}');
        this.loader = document.querySelector("#personalize-loader");

        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      connectedCallback() {
        this.personalizeForm.addEventListener("submit", (e) =>
          this.personalizeFormSubmit(e)
        );
        this.resultBackButton.addEventListener("click", () =>
          this.showPersonalizeBlock()
        );
        this.personaliseAddToCartBtn.addEventListener("click", () =>
          this.form.requestSubmit()
        );
        this.watchStandardInputs();
        this.watchCustomSelects();
        this.watchRadioInputs();
      }

      showPersonalizeBlock() {
        this.personalizeResultBlock.classList.add("!hidden");
        this.heroContent.classList.remove('hidden');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const payload = {};
        const bundleProp = formData.get("properties[_bundle]");

        if (bundleProp) {
          payload.properties = {
            _bundle: bundleProp,
          };
        }
                
        if (
          this.personalizeProperties &&
          Object.keys(this.personalizeProperties).length > 0
        ) {
          payload.properties = {
            ...this.personalizeProperties,
          };
        }

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant({ id: variantId }, quantity, payload, {
          ensureUnique: this.dataset.ensureUnique === "true",
        }).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }

      personalizeFormSubmit(e) {
        e.preventDefault();
        if (!this.validatePersonalizeForm()) return;

        const formData = new FormData(e.target);
        const json = Object.fromEntries(formData.entries());
        const transformed = this.transformData(json);

        this.personalizeProperties = Object.fromEntries(
            Object.entries(transformed).filter(([key, value]) => value != null && value !== '')
        );

        this.onShowPreview(e);
        this.renderResultMarkup(json);
        this.chooseCurrentVariant(json);
      }

      validateCustomSelects() {
        const requiredHiddenInputs = this.personalizeForm.querySelectorAll(
          'input[type="hidden"][required]'
        );
        let isValid = true;

        requiredHiddenInputs.forEach((input) => {
          const wrapper = input.closest(".custom-select");

          if (!input.value.length) {
            isValid = false;
            wrapper.classList.add("custom-select--error");
          } else {
            wrapper.classList.remove("custom-select--error");
          }
        });

        return isValid;
      }

      watchCustomSelects() {
        const customSelects =
          this.personalizeForm.querySelectorAll(".custom-select");

        customSelects.forEach((selectWrapper) => {
          const options = selectWrapper.querySelectorAll(".select-option");

          if (options.length === 0) return;

          options.forEach((option) => {
            option.addEventListener("click", () => {
              selectWrapper.classList.remove("custom-select--error");
            });
          });
        });
      }

      watchStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        fields.forEach((field) => {
          field.addEventListener("input", () => {
            field.classList.remove("input--error", "border-[#ff564f]");
          });
        });
      }

      validatePersonalizeForm() {
        const isCustomSelectsValid = this.validateCustomSelects();
        const isRadiosValid = this.validateRadioGroups();

        return isCustomSelectsValid && isRadiosValid;
      }

      async onShowPreview(e) {
        e.preventDefault();
        const button = document.querySelector("#show-result-btn");
        const errorBox = document.querySelector("#personalize-error-message");

        button.disabled = true;
        button.classList.add("loading");
        const originalText = button.innerHTML;
        button.innerHTML = "Loading...";
        document.body.classList.add("lock");
        this.loader.classList.remove("!hidden");

        const formData = new FormData(this.personalizeForm);
        const json = Object.fromEntries(formData.entries());
        const transformed = this.transformData(json);
        const cleanedParams = this.cleanParams(transformed);
        const requiredKeys = [
          "date",
          "personName",
        ];
        const params = {};

        const uiReset = () => {
          this.showPersonalizeResult();
          button.disabled = false;
          button.classList.remove("loading");
          button.innerHTML = originalText;
          this.loader.classList.add("!hidden");
          document.body.classList.remove("lock");
        };

        for (const key of requiredKeys) {
        //  if (!cleanedParams[key]) {
        //     continue;
        //   }
          params[key] = cleanedParams[key] || "";
        }

        const paramsString = JSON.stringify(params);

        if (this.lastPreviewParams === paramsString) {
          uiReset();
          return;
        }

        this.lastPreviewParams = paramsString;
        const queryString = new URLSearchParams(params).toString();
        const url = `https://api.fiocompanies.com/v1/products/birthdate-candle/preview?${queryString}`;
        
        try {
          const previewImages = await this.getPreviewImages(url);

          window.addDynamicSlides(previewImages);
          window.addSlidesToProductModal(previewImages);
        } catch (error) {
          if (errorBox) {
            errorBox.classList.remove("hidden");
            setTimeout(() => {
              errorBox.classList.add("hidden");
            }, 8000);
          }
          console.error("Failed to load preview image:", error.message);
        } finally {
          uiReset();
        }
      }

      async getPreviewImages(url) {
        const response = await fetch(url);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "Failed to fetch preview image");
        }

        const data = await response.json();
        
        return data.images;
      }

      transformData(data) {
        const {
          _personMonth,
          _personDay,
          ...rest
        } = data;

        return {
          ...rest,
          Date: `${_personMonth}-${_personDay}`,
          _date: `${_personMonth}-${_personDay}`,
        };
      }
      
      buildEventDate = (month, day, delimiter = "-", format = "MD") => {
        if (!month || !day) return "";

        if (format === "MD") {
          return `${month}${delimiter}${day}${delimiter}`;
        }

        return `${delimiter}${month}${delimiter}${day}`;
      }

      getZodiacSign = (month, day) => {
        if (!month || !day) return "";

        const m = parseInt(month, 10);
        const d = parseInt(day, 10);

        const zodiacRanges = [
          { sign: "Capricorn", start: [12, 22], end: [1, 19] },
          { sign: "Aquarius", start: [1, 20], end: [2, 18] },
          { sign: "Pisces", start: [2, 19], end: [3, 20] },
          { sign: "Aries", start: [3, 21], end: [4, 19] },
          { sign: "Taurus", start: [4, 20], end: [5, 20] },
          { sign: "Gemini", start: [5, 21], end: [6, 20] },
          { sign: "Cancer", start: [6, 21], end: [7, 22] },
          { sign: "Leo", start: [7, 23], end: [8, 22] },
          { sign: "Virgo", start: [8, 23], end: [9, 22] },
          { sign: "Libra", start: [9, 23], end: [10, 22] },
          { sign: "Scorpio", start: [10, 23], end: [11, 21] },
          { sign: "Sagittarius", start: [11, 22], end: [12, 21] },
        ];

        for (const zodiac of zodiacRanges) {
          const [startMonth, startDay] = zodiac.start;
          const [endMonth, endDay] = zodiac.end;

          const afterStart =
            m > startMonth || (m === startMonth && d >= startDay);
          const beforeEnd = m < endMonth || (m === endMonth && d <= endDay);

          if (startMonth > endMonth) {
            if (afterStart || beforeEnd) return zodiac.sign;
          } else {
            if (afterStart && beforeEnd) return zodiac.sign;
          }
        }

        return "";
      }

      cleanParams(obj) {
        const cleaned = {};
        for (const key in obj) {
          if (key.startsWith("_")) {
            cleaned[key.substring(1)] = obj[key];
          } else {
            cleaned[key] = obj[key];
          }
        }
        return cleaned;
      }

      async renderResultMarkup(personalizeProperties) {    
        function getOrdinalSuffix(n) {
          if (n % 100 >= 11 && n % 100 <= 13) return "th";
          switch (n % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
          }
        }
        
        const { _personMonth, _personDay } = personalizeProperties;
        const zodiac = this.getZodiacSign(_personMonth, _personDay);
        const month = Number(personalizeProperties._personMonth);
        const day = Number(personalizeProperties._personDay);
        const dayLabel = document.querySelector('#day-label');
        const scentsLabel = document.querySelector('#scents-label');
        const dataTitle = document.querySelector('#data-title');
        
        const productData = await this.getContentfulData(zodiac, `${month}/${day}`)
        const formattedDate = this.formatDate(_personMonth, _personDay);
        const suffix = getOrdinalSuffix(day);

        if(dataTitle) dataTitle.innerHTML = `${formattedDate}<sup>${suffix}</sup>`;
        if(dayLabel && productData.dayTitle) dayLabel.textContent = `${formattedDate}: ${productData.dayTitle}`;
        if (scentsLabel) {
          const scentValues = Object.keys(productData)
              .filter(key => key.startsWith('scentNote'))
              .map(key => productData[key])
              .filter(Boolean);
          scentsLabel.textContent = `Scents: ${scentValues.join(' • ')}`;
          this.personalizeProperties.Scents = `${scentValues.join(' • ')}`
        }
      }

      formatDate(month, day) {
        const monthNames = [
          "January", "February", "March", "April", "May", "June", 
          "July", "August", "September", "October", "November", "December"
        ];
        const m = Number(month);
        const d = Number(day);
        if (!m || !d) return '';
        return `${monthNames[m - 1]} ${d}`;
      }

      showPersonalizeResult() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.remove("!hidden");
        this.heroContent.classList.add("hidden");
      }

      validateRadioGroups() {
        let isValid = true;

        const requiredRadios = this.personalizeForm.querySelectorAll(
          'input[type="radio"][required]'
        );
        const names = [...new Set(Array.from(requiredRadios).map(r => r.name))];
        
        names.forEach((name) => {
          const group = this.personalizeForm.querySelectorAll(`input[name="${name}"]`);
          const checked = Array.from(group).some((radio) => radio.checked);
          
          if (!checked) {
            isValid = false;
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
              label.style.boxShadow = "0 0 0 3px #ff564f";
            });
          } else {
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
              label.style.boxShadow = "";
            });
          }
        });

        return isValid;
      }

      watchRadioInputs() {
        const radios = this.personalizeForm.querySelectorAll('input[type="radio"][required]');
        const displayText = document.querySelector('#current-background-swatch-text');

        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            const group = this.personalizeForm.querySelectorAll(`input[name="${radio.name}"]`);
            group.forEach(r => {
              const label = this.personalizeForm.querySelector(`label[for="${r.id}"]`);
              if (label) label.style.boxShadow = "";
            });

            const selectedLabel = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
            if (selectedLabel) selectedLabel.style.boxShadow = "0 0 0 3px #fff, 0 0 0 6px #000";

            if (displayText) {
              displayText.textContent = radio.value;
            } 
          });
        });
      }

      chooseCurrentVariant(props) {
        const { _personMonth, _personDay, _personName } = props;
        const select = document.querySelector('select.form-select');

        if (!select) return;

        const zodiac = this.getZodiacSign(_personMonth, _personDay);
        const nameFilled = _personName && _personName.trim() !== '';
        const nameStatus = nameFilled ? 'Customized' : 'Standard';
        
        const targetOption = Array.from(select.options).find(opt => {
          return opt.getAttribute('data-option-1') === zodiac && opt.getAttribute('data-option-2') === nameStatus;
        });

        if (targetOption) {
          select.value = targetOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          const variantId = Number(select.value);
            const variant = this.productData?.product?.variants?.find(v => Number(v.id) === variantId);

            if (variant) {
              const priceElements = document.querySelectorAll('.product-price');
              const price = (variant.price / 100).toFixed(2);
              priceElements.forEach(el => {
                  el.textContent = `$${price}`;
              });
            }
        } else {
          console.warn('No matching variant found for', zodiac, nameStatus);
        }
      }

      getContentfulData = async (zodiac, day) => {
        const SPACE_ID = "a51riaw87gj9"
        const ENV = "master"
        const TOKEN = "Apzv2K-x4V19tZ_cbzLLZiwi7SC7bjgRaFFPchV4UUc"

        const baseUrl = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/${ENV}`

        const zodiacRes = await fetch(
          `${baseUrl}/entries?access_token=${TOKEN}&content_type=birthdateCandlesZodiacSign&fields.title=${encodeURIComponent(zodiac)}&select=fields.scentNote1,fields.scentNote2,fields.scentNote3&limit=1`
        )
        const zodiacData = await zodiacRes.json()

        const dayRes = await fetch(
          `${baseUrl}/entries?access_token=${TOKEN}&content_type=birthdateCandlesDay&fields.title=${encodeURIComponent(day)}&select=fields.dayTitle&limit=1`
        )
        const dayData = await dayRes.json()
        const zodiacItem = zodiacData?.items?.[0]?.fields
        const dayItem = dayData?.items?.[0]?.fields
        return {
          scentNote1: zodiacItem?.scentNote1,
          scentNote2: zodiacItem?.scentNote2,
          scentNote3: zodiacItem?.scentNote3,
          dayTitle: dayItem?.dayTitle
        }
      }
    }
  );
}